import { useMsal } from "@azure/msal-react";
import { BaseApiService } from "./baseApiService";

export const useContactService = () => {
    const { instance } = useMsal();
    return new ContactService(instance);
};

class ContactService extends BaseApiService {

    async getContactsByFirm() {
        const url = 'Contact';
        return await this.get(url);
    }
}